exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.banned {\n\tbackground: rgba(200, 0, 0, 0.2);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/doctors/detail/doctor-status.component.css
// module id = 1055
// module chunks = 1